// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as CarrinhoCompartilhadoRouteImport } from './routes/carrinho-compartilhado'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DecoRenderRouteImport } from './routes/deco/render'
import { Route as DecoMetaRouteImport } from './routes/deco/meta'
import { Route as DecoInvokeSplatRouteImport } from './routes/deco/invoke.$'

const CarrinhoCompartilhadoRoute = CarrinhoCompartilhadoRouteImport.update({
            id: '/carrinho-compartilhado',path: '/carrinho-compartilhado',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DecoRenderRoute = DecoRenderRouteImport.update({
            id: '/deco/render',path: '/deco/render',getParentRoute: () => rootRouteImport
          })
const DecoMetaRoute = DecoMetaRouteImport.update({
            id: '/deco/meta',path: '/deco/meta',getParentRoute: () => rootRouteImport
          })
const DecoInvokeSplatRoute = DecoInvokeSplatRouteImport.update({
            id: '/deco/invoke/$',path: '/deco/invoke/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,CarrinhoCompartilhadoRoute: CarrinhoCompartilhadoRoute,DecoMetaRoute: DecoMetaRoute,DecoRenderRoute: DecoRenderRoute,DecoInvokeSplatRoute: DecoInvokeSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)